import React, { useEffect, useState } from "react";
import { useSphereOneProvider } from "../utils/SphereOneHooks";
const qorbiServices = require("../context/QorbiService");
const quests = [
  // 4 HOURS
  {
    name: "Survive 2 minutes",
    description: "Complete a traning ground",
    cooldown: 4,
    reward: 40,
  },
  {
    name: "5 Pistol Kills",
    description: "Kill 5 mobs using a pistol",
    cooldown: 4,
    reward: 50,
  },
  {
    name: "10 Kills with SMG",
    description: "Kill 10 mobs using a SMG",
    cooldown: 4,
    reward: 60,
  },
  // 6 HOURS
  {
    name: "Kill 6 Anubis",
    description: "Kill 6 Anubis",
    cooldown: 6,
    reward: 75,
  },
  {
    name: "Kill Anubis - Sniper",
    description: "Defeat the fearsome Anubis using a sniper weapon.",
    cooldown: 4,
    reward: 50,
  },
  {
    name: "3 Melee Kills",
    description: "3 Melee Kills",
    cooldown: 6,
    reward: 60,
  },
  {
    name: "Kill 3 Ice Golems",
    description: "Kill 3 Ice Golems",
    cooldown: 6,
    reward: 75,
  },
  {
    name: "10 Headshots with Pistol",
    description: "10 Headshots with Pistol",
    cooldown: 6,
    reward: 65,
  },
  // 24 HOURS
  {
    name: "Eliminate 20 Bots",
    description: "Eliminate 20 Bots",
    cooldown: 24,
    reward: 200,
  },
  {
    name: "30 Headshots in 1 Training Run",
    description: "30 Headshots in 1 Training Run",
    cooldown: 24,
    reward: 250,
  },
];
// Helper para convertir ms a hh:mm:ss
const formatTime = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const QuestTable = ({ quests }) => {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const updated = {};
        for (const quest of quests) {
          const remaining = Math.max(
            (prev[quest.name] ?? quest.remainingTime) - 1000,
            0
          );

          updated[quest.name] = remaining;
        }
        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [quests]);

  return (
    <div className="training-quests-container">
      <h2 className="training-quests-title">Training Quests</h2>
      <div className="training-table-wrapper">
        <table className="training-quests-table">
          <thead>
            <tr>
              <th>Quest</th>
              <th className="hide-mobile">Description</th>
              <th className="hide-mobile">Cooldown (hrs)</th>
              <th>FATE</th>
              <th>Time Left</th>
            </tr>
          </thead>
          <tbody>
            {quests.map((quest) => (
              <tr key={quest.name}>
                <td>{quest.name}</td>
                <td className="hide-mobile">{quest.description}</td>
                <td className="hide-mobile">{quest.cooldown}</td>
                <td>
                  <div className="training-reward">
                    {quest.reward}
                    {/* opcional ícono */}
                    {/* <div className="training-reward-icon"><img src={qorbi_coin} alt="coin" /></div> */}
                  </div>
                </td>
                <td className="training-time-left">
                  {(timeLeft[quest.name] ?? quest.remainingTime) > 0 ? (
                    formatTime(timeLeft[quest.name] ?? quest.remainingTime)
                  ) : (
                    <span className="quest-ready">Ready to start!</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TrainingQuest = () => {
  const { qorbiUserData } = useSphereOneProvider();
  const [enrichedQuests, setEnrichedQuests] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const cooldownData = await qorbiServices.getQuestByUser();
      const enriched = quests.map((quest) => {
        const cooldownInfo = cooldownData.find((q) => q.name === quest.name);
        return {
          ...quest,
          remainingTime: cooldownInfo ? cooldownInfo.remainingTime : 0,
        };
      });
      setEnrichedQuests(enriched);
    };

    fetchData();
  }, []);

  if (!enrichedQuests)
    return <div className="training-loading">Loading quests...</div>;

  return (
    <div className="training-wrapper">
      <QuestTable quests={enrichedQuests} />
    </div>
  );
};

export default TrainingQuest;
